import { ChangeDetectionStrategy, Component } from "@angular/core";

import { GameAnimationsComponent } from "../game-animations/game-animations.component";

@Component({
  selector: "mn-game-panel",
  templateUrl: "./game-panel.component.html",
  styleUrls: ["./game-panel.component.scss"],
  imports: [GameAnimationsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GamePanelComponent {}
